module.exports = __webpack_public_path__ + "static/media/OFL.f20c9954.txt";